<template>
  <div>
    <index-loader />
    <layouts-header />
    <layouts-sidebar />
    
    <div class="page-wrapper">
      <div class="content">
        <div class="row">
          <div class="col-md-12">
            <!-- KPI Summary Cards -->
            <div class="row">
              <!-- Total Leads -->
              <div class="col-md-3 col-sm-6 d-flex">
                <div class="card kpi-card w-100">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <p class="kpi-title">Total Leads</p>
                        <h3 class="kpi-value">{{ DashboardSummary.TotalLeads }}</h3>
                      </div>
                      <div class="kpi-icon bg-primary">
                        <i class="ti ti-users"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Total Leads Won -->
              <div class="col-md-3 col-sm-6 d-flex">
                <div class="card kpi-card w-100">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <p class="kpi-title">Total Leads Won</p>
                        <h3 class="kpi-value text-success">{{ DashboardSummary.TotalLeadsWon }}</h3>
                      </div>
                      <div class="kpi-icon bg-success">
                        <i class="ti ti-check"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Top Employee -->
              <div class="col-md-3 col-sm-6 d-flex">
                <div class="card kpi-card w-100">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <p class="kpi-title">Top Performing Employee</p>
                        <h6 class="mb-1">{{ DashboardSummary.TopPerformingEmployee }}</h6>
                        <small class="text-muted">
                          Won Leads: <b>{{ DashboardSummary.LeadWon }}</b>
                        </small>
                      </div>
                      <div class="kpi-icon bg-info">
                        <i class="ti ti-user-star"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Top Exhibition -->
              <div class="col-md-3 col-sm-6 d-flex">
                <div class="card kpi-card w-100">
                  <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center">
                      <div>
                        <p class="kpi-title">Top Exhibition</p>
                        <h6 class="mb-1">{{ DashboardSummary.ExhibitionName }}</h6>
                        <small class="text-muted">
                          Leads: <b>{{ DashboardSummary.ExhibitionLeadCount }}</b>
                        </small>
                      </div>
                      <div class="kpi-icon bg-warning">
                        <i class="ti ti-building-store"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Charts Row 1 -->
            <div class="row">
              <div class="col-md-6 d-flex">
                <div class="card w-100">
                  <div class="card-header border-0 pb-0">
                    <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4>
                        <i class="ti ti-grip-vertical me-1"></i>Priority Wise Leads
                      </h4>
                    </div>
                  </div>
                  <div class="card-body">
                    <div id="leadpiechartLeads" v-if="!loading">
                      <apexchart
                        type="pie"
                        height="450"
                        :options="leadPriorityPieChart.pieCharts"
                        :series="leadPriorityPieChart.series"
                      />
                    </div>
                    <div v-else>
                      <p>loading..</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="col-md-6 d-flex">
                <div class="card w-100">
                  <div class="card-header border-0 pb-0">
                    <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4>
                        <i class="ti ti-grip-vertical me-1"></i>Exhibition Wise Leads
                      </h4>
                      <div class="daterange-picker d-flex align-items-center justify-content-center">
                        <div class="form-sort me-2">
                          <i class="ti ti-calendar"></i>
                          <input
                            type="text"
                            class="form-control date-range bookingrange"
                            ref="dateRangeInput"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div id="contacts-analysis-leads" v-if="!exhibitionLoad">
                      <apexchart
                        type="bar"
                        height="450"
                        :options="ExibhitionWiseCharts.chartOptions"
                        :series="ExibhitionWiseCharts.series"
                      ></apexchart>
                    </div>
                    <div v-else>
                      <p>loading..</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Charts Row 2 -->
            <div class="row">
              <div class="col-md-6 d-flex">
                <div class="card w-100">
                  <div class="card-header border-0 pb-0">
                    <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4>
                        <i class="ti ti-grip-vertical me-1"></i>Lead Status Funnel
                      </h4>
                    </div>
                  </div>
                  <div class="card-body">
                    <div id="project-stage" v-if="!loading">
                      <apexchart
                        type="bar"
                        height="450"
                        :options="funnelChartOptions"
                        :series="projectStaCharts.series"
                      />
                    </div>
                    <div v-else>
                      <p>loading..</p>
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="col-md-6 d-flex">
                <div class="card w-100">
                  <div class="card-header border-0 pb-0">
                    <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4>
                        <i class="ti ti-grip-vertical me-1"></i>Leads Created By
                      </h4>
                      <div>
                        <multiselect
                          v-model="selectedYear"
                          :options="yearsList"
                          :searchable="true"
                          :close-on-select="true"
                          :show-labels="false"
                          label="label"
                          track-by="value"
                        >
                        </multiselect>
                      </div>
                    </div>
                  </div>
                  <div class="card-body">
                    <div id="contact-report" v-if="!leadsCreatedLoading">
                      <apexchart
                        type="bar"
                        height="500"
                        :options="contactReportChart.reportCharts"
                        :series="contactReportChart.series"
                      ></apexchart>
                    </div>
                    <div v-else>
                      <p>loading...</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Charts Row 3 -->
            <div class="row">
              <div class="col-md-6 d-flex">
                <div class="card w-100">
                  <div class="card-header border-0 pb-0">
                    <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4>
                        <i class="ti ti-grip-vertical me-1"></i>Employee Wise Leads
                      </h4>
                      <div class="btn-group" role="group">
                        <button
                          type="button"
                          class="btn btn-outline-primary"
                          :class="{ active: selectedButton === 'created' }"
                          :disabled="selectedButton === 'created'"
                          @click="EmployeeWiseButtonClick('created')"
                        >
                          Leads Created
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-primary"
                          :class="{ active: selectedButton === 'own' }"
                          :disabled="selectedButton === 'own'"
                          @click="EmployeeWiseButtonClick('own')"
                        >
                          Leads Own
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="card-body" v-if="!employeeChartLoad">
                    <div id="contact-report1">
                      <apexchart
                        type="bar"
                        height="450"
                        :options="employeeWiseChart.chartOptions"
                        :series="employeeWiseChart.series"
                      />
                    </div>
                  </div>
                  <div v-else>
                    <p>loading..</p>
                  </div>
                </div>
              </div>
              
              <div class="col-md-6 d-flex">
                <div class="card w-100">
                  <div class="card-header border-0 pb-0">
                    <div class="d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                      <h4><i class="ti ti-grip-vertical me-1"></i> Leads (2025)</h4>
                    </div>
                  </div>
                  <div class="card-body">
                    <div id="contact-report2" v-if="!loading">
                      <apexchart
                        type="line"
                        height="450"
                        :options="multiLineChart.chartOptions"
                        :series="multiLineChart.series"
                      />
                    </div>
                    <div v-else>
                      <p>loading..</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <project-dashboard-modal />
  </div>
</template>

<script>
import http from "@/utils/http";
import moment from "moment";
import Multiselect from "vue-multiselect";
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import DateRangePicker from "daterangepicker";

// Chart configurations
import {
  leadPriorityChartConfig,
  exhibitionChartConfig,
  funnelChartConfig,
  contactReportChartConfig,
  employeeWiseChartConfig,
  multiLineChartConfig
} from '@/config/chartConfigs';

export default {
  components: {
    Multiselect,
  },
  data() {
    return {
      title: "Leads Dashboard",
      DashboardSummary: {
        TotalLeads: 0,
        TotalLeadsWon: 0,
        ExhibitionName: "",
        ExhibitionLeadCount: 0,
        TopPerformingEmployee: "",
        LeadWon: 0,
      },
      charts: {
        leadPriority: leadPriorityChartConfig(),
        exhibition: exhibitionChartConfig(),
        funnel: funnelChartConfig(),
        contactReport: contactReportChartConfig(),
        employeeWise: employeeWiseChartConfig(),
        multiLine: multiLineChartConfig()
      },
      startDate: moment("1970-01-01"),
      endDate: moment(),
      selectedButton: "created",
      selectedYear: null,
      yearsList: [],
      loading: true,
      exhibitionLoad: true,
      employeeChartLoad: true,
      leadsCreatedLoading: true,
    };
  },
  computed: {
    leadPriorityPieChart() {
      return this.charts.leadPriority;
    },
    ExibhitionWiseCharts() {
      return this.charts.exhibition;
    },
    projectStaCharts() {
      return this.charts.funnel;
    },
    contactReportChart() {
      return this.charts.contactReport;
    },
    employeeWiseChart() {
      return this.charts.employeeWise;
    },
    multiLineChart() {
      return this.charts.multiLine;
    },
    // Fixed funnel chart options with proper context
    funnelChartOptions() {
      const options = { ...this.charts.funnel.stagesCharts };
      
      // Add data labels formatter with proper context
      options.dataLabels = {
        enabled: true,
        formatter: (val, opts) => {
          const index = opts.dataPointIndex;
          const label = opts.w.globals.labels[index];
          const realValue = this.charts.funnel.funnelRealValues[index];
          return `${label}: ${realValue}`;
        },
        textAnchor: 'middle',
        style: {
          fontSize: '12px',
          fontWeight: 500,
          colors: ['#000']
        }
      };
      
      // Add tooltip formatter
      options.tooltip = {
        y: {
          formatter: (val, opts) => {
            const index = opts.dataPointIndex;
            return this.charts.funnel.funnelRealValues[index];
          }
        }
      };
      
      return options;
    }
  },
  created() {
    this.generateYears(2025);
  },
  mounted() {
    this.loadLeadDashboardChartData();
    this.loadexhibitionChartData();
    this.EmployeeWiseButtonClick(this.selectedButton);
    this.LeadsCreatedByChart();

    if (this.$refs.dateRangeInput) {
      new DateRangePicker(
        this.$refs.dateRangeInput,
        {
          startDate: this.startDate,
          endDate: this.endDate,
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "Last 30 Days": [moment().subtract(29, "days"), moment()],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [
              moment().subtract(1, "month").startOf("month"),
              moment().subtract(1, "month").endOf("month"),
            ],
            "All Time": [moment("1970-01-01"), moment()],
          },
        },
        this.booking_range
      );
    }
  },
  watch: {
    selectedYear(newValue) {
      if (newValue) {
        this.LeadsCreatedByChart();
      }
    },
  },
  methods: {
    generateYears(startYear = 2020) {
      const currentYear = new Date().getFullYear();
      this.yearsList = [];

      for (let y = startYear; y <= currentYear + 1; y++) {
        this.yearsList.push({
          label: String(y),
          value: y,
        });
      }

      this.selectedYear = this.yearsList.find((y) => y.value === currentYear);
    },
    
    booking_range(start, end) {
      this.startDate = start ? start.format("YYYY-MM-DD") : null;
      this.endDate = end ? end.format("YYYY-MM-DD") : null;
      this.loadexhibitionChartData();
      return start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
    },
    
    async loadLeadDashboardChartData() {
      this.loading = true;
      const endpoint = `/leads-dashboard-chart-data`;

      try {
        const response = await http.get(endpoint);
        this.processDashboardResponse(response.data);
        this.loading = false;
      } catch (error) {
        console.error(error);
        this.loading = false;
      }
    },
    
    processDashboardResponse(data) {
      // Dashboard Summary
      this.DashboardSummary = {
        TotalLeads: data.DashboardSummary?.TotalLeads || 0,
        TotalLeadsWon: data.DashboardSummary?.TotalLeadsWon || 0,
        ExhibitionName: data.DashboardSummary?.ExhibitionName || "",
        ExhibitionLeadCount: data.DashboardSummary?.ExhibitionLeadCount || 0,
        TopPerformingEmployee: data.DashboardSummary?.TopPerformingEmployee || "",
        LeadWon: data.DashboardSummary?.LeadWon || 0,
      };

      // Priority Wise Pie Chart
      if (data.priorityWiseChart) {
        this.charts.leadPriority.series = data.priorityWiseChart.series.map(Number);
        this.charts.leadPriority.pieCharts.labels = data.priorityWiseChart.labels;
      }

      // Lead Status Funnel Chart
      if (data.leadStageWiseChart) {
        const labels = data.leadStageWiseChart.labels || [];
        const realValues = data.leadStageWiseChart.series || [];
        
        this.charts.funnel.funnelRealValues = realValues;
        this.charts.funnel.stagesCharts.xaxis.categories = labels;
        
        // Generate static funnel width
        const staticValues = labels.map((_, index) => {
          return (labels.length - index) * 100;
        });
        
        this.charts.funnel.series[0].data = staticValues;
      }

      // Multi Line Monthly Chart
      if (data.multiLineMonthlyChart) {
        this.charts.multiLine.chartOptions.xaxis.categories = data.multiLineMonthlyChart.labels;
        this.charts.multiLine.series = data.multiLineMonthlyChart.series;
      }
    },
    
    async loadexhibitionChartData() {
      this.exhibitionLoad = true;
      const endpoint = `/exhibition-wise-chart-data`;

      try {
        const response = await http.post(endpoint, {
          startDate: this.startDate,
          endDate: this.endDate,
        });

        if (response.data.exhibitionWiseChart) {
          this.charts.exhibition.chartOptions.xaxis.categories = 
            response.data.exhibitionWiseChart.labels;

          this.charts.exhibition.series = [{
            name: "Leads",
            data: response.data.exhibitionWiseChart.series.map(Number),
          }];

          this.charts.exhibition.chartOptions.chart.height =
            response.data.exhibitionWiseChart.labels.length * 35;
        }

        this.exhibitionLoad = false;
      } catch (error) {
        console.error(error);
        this.exhibitionLoad = false;
      }
    },
    
    async EmployeeWiseButtonClick(type) {
      this.employeeChartLoad = true;
      this.selectedButton = type;
      const endpoint = `/employee-wise-chart-data`;

      try {
        const response = await http.post(endpoint, {
          type: this.selectedButton,
        });

        if (response.data.EmployeeWiseChart) {
          this.charts.employeeWise.chartOptions.xaxis.categories =
            response.data.EmployeeWiseChart.labels;

          this.charts.employeeWise.series = [{
            name: "Leads",
            data: response.data.EmployeeWiseChart.series,
          }];

          this.charts.employeeWise.chartOptions.chart.height =
            response.data.EmployeeWiseChart.labels.length * 35;
        }

        this.employeeChartLoad = false;
      } catch (error) {
        console.error(error);
        this.employeeChartLoad = false;
      }
    },
    
    async LeadsCreatedByChart() {
      if (!this.selectedYear?.value) return;
      
      this.leadsCreatedLoading = true;
      const endpoint = `/leads-created-year-chart-data`;

      try {
        const response = await http.post(endpoint, {
          selected_year: this.selectedYear.value,
        });

        if (response.data.LeadsCreatedByYearChart) {
          this.charts.contactReport.reportCharts.xaxis.categories =
            response.data.LeadsCreatedByYearChart.labels;

          this.charts.contactReport.series = [{
            name: "Leads",
            data: response.data.LeadsCreatedByYearChart.series,
          }];
        }

        this.leadsCreatedLoading = false;
      } catch (error) {
        console.error(error);
        this.leadsCreatedLoading = false;
      }
    },
  },
};
</script>